import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { SmartTagsWysiwygLayoutProps, Tag, useSegmentedSmartTagsChooserHelper } from 'ui-builder';
import QuillWysiwygLayout from '../../../form/input/layout/QuillWysiwygLayout';
import HowToUseSmartTagsLink from '../../../form/HowToUseSmartTagsLink';

import './SmartTagsWysiwygLayout.scss';

function SmartTagsQuillLayoutWrapper(props: SmartTagsWysiwygLayoutProps) {

  const notDeprecatedTags = useMemo(
    () => props.availableTags.filter((tag) => !tag.isDeprecated),
    [props.availableTags.length],
  );

  useEffect(() => {
    (window as any).smartTags = notDeprecatedTags;
  }, [notDeprecatedTags.length]);

  const quillRef = useRef<{
    pasteTextOnCursorPosition: (text: string) => void;
  } | null>(null);

  const smartTagsChooserHelper = useSegmentedSmartTagsChooserHelper();

  const modules = {
    mention: {
      allowedChars: /^[A-Za-z0-9\\.]*$/,
      dataAttributes: ['id', 'value', 'existing'],
      attributes: ['title'],
      mentionDenotationChars: ['#'],
      maxChars: 100,
      source: useCallback((searchTerm: string, renderList: any, mentionChar: string) => {
        if (mentionChar === '#') {
          const allTags = (window as any).smartTags || [];

          smartTagsChooserHelper.onTagTyped(allTags, searchTerm, renderList);
        }
      }, []),
      onSelect: useCallback((item: any, insertItem: any) => {
        smartTagsChooserHelper.onTagSelected(
          item,
          insertItem,
          (tag: Tag) => {
            quillRef?.current?.pasteTextOnCursorPosition(`${tag.value}.`);
          }
        );
      }, []),
      renderItem: useCallback((item: any, searchTerm: string) => {
        const div = document.createElement('div');
        div.textContent = item.value;
        return div;
      }, []),
      onBeforeClose: useCallback((quill: any) => {
        return false;
      }, []),
    },
    clipboard: {
      matchVisual: false
    },
  };

  return (
    <>
      {!props.hideHowToUseLink && (
        <HowToUseSmartTagsLink />
      )}
      <QuillWysiwygLayout
        {...props}
        modules={modules}
        quillRef={quillRef}
      />
    </>
  );
}

export default function SmartTagsWysiwygLayout(
  props: SmartTagsWysiwygLayoutProps,
) {

  return (
    <SmartTagsQuillLayoutWrapper
      {...props}
    />
  );
}
